import styled from '@emotion/styled';
import { colors, Stack, Typography } from '@ui-components/neo.tax';

// Matches StyledConnectProvider so the GitHub slides sit at the same modal width as every other
// provider; without it the modal stretches to the viewport.
export const StyledConnectGitHub = styled.div({
  width: 512,
});

export const StyledGitHubBody = styled(Stack)({
  gap: 16,
  marginTop: 20,
});

export const StyledGitHubPrompt = styled(Typography)({
  color: colors.gray[500],
  textAlign: 'center',
});
